import { c as _c } from "react/compiler-runtime";
import { classNames, Flex, SkeletonLine } from "@opensea/ui-kit";
import { range } from "es-toolkit/math";
export function ItemMetadataChipsSkeleton(t0) {
  const $ = _c(10);
  const {
    variant: t1,
    className,
    count: t2
  } = t0;
  const variant = t1 === undefined ? "default" : t1;
  const count = t2 === undefined ? 3 : t2;
  let t3;
  if ($[0] !== className) {
    t3 = classNames("scrollbar-hidden h-[18px] w-full gap-2 overflow-auto", className);
    $[0] = className;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== count || $[3] !== variant) {
    let t5;
    if ($[5] !== variant) {
      t5 = index => <SkeletonLine className="h-full w-14 rounded" key={index.toString()} variant={variant} />;
      $[5] = variant;
      $[6] = t5;
    } else {
      t5 = $[6];
    }
    t4 = range(count).map(t5);
    $[2] = count;
    $[3] = variant;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = <Flex className={t3}>{t4}</Flex>;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}